export default __webpack_public_path__ + "static/media/vote-indicator.12bb0dbd.svg";